module.exports = __webpack_public_path__ + "img/sentrys-logo-sm.68e2d45f.png";